import styled from 'styled-components';

export const ModalContainer = styled.div``;

export const Content = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;

  h1 {
    margin-top: 20px;
    font-size: 2rem;
    font-weight: 600;
    color: ${({ theme }) => theme.purple};
  }

  img {
    width: 200px;
    height: 200px;
    margin-bottom: 12px;
  }

  span {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    padding: 0 26px;

    max-width: 450px;

    p {
      font-size: 1.5rem;
      margin: 0;
    }
  }
`;

export const ContainerFooter = styled.footer`
  display: flex;

  button {
    border: 0;
    height: 50px;
    width: 100%;
    font-size: 1.5rem;
    letter-spacing: 1.5px;
    transition: filter 0.2s;

    background: ${({ theme }) => theme.purple};

    &:hover {
      background: ${({ theme }) => theme.purple};
      color: #fff;
      filter: brightness(0.9);
    }
  }
`;
